import { FunctionComponent, useEffect, useState } from "react";
import Modal from "./Modal";
import Button from "../Button";
import { buttonTypes, userTypes } from "src/utils/types";
import { useAuth } from "src/context/AuthContext";
import { dynamo, sendgrid } from "src/utils";
import {
  TextInputWithRegister,
} from "src/components/inputs";
import { useForm } from "react-hook-form";
import { ToastStatus, useToast } from "src/context/ToastContext";

interface IInviteClientModalProps {
  open: boolean;
  toggleModal: () => void;
}

const InviteClientModal: FunctionComponent<IInviteClientModalProps> = ({
  open,
  toggleModal,
}) => {
  const { setToast } = useToast();
  const { user } = useAuth();
  const { register, handleSubmit } = useForm({
    defaultValues: {
      email: "",
      name: "",
    },
  });

  const save = async (values: any) => {
    if (!user) return;
    try {
      const { name, email } = values;

      const result = await sendgrid.sendInviteClient(name, email, user?.userId);

      if (result.status === 202) {
        setToast({
          message: "Invitation Email Sent",
          status: ToastStatus.FAIL,
        });

        if (user?.userType === userTypes.AccountTypes.REFERRAL) {
          Number.isNaN(user.metadata.referralCount)
            ? (user.metadata.referralCount = 1)
            : (user.metadata.referralCount += 1);

          await dynamo.mutations.putUser(user);
        }

        toggleModal();
      }
    } catch (error: any) {
      setToast({
        message: error?.message || "Client Invitation Failed",
        status: ToastStatus.FAIL,
      });
    }
  };

  return (
    <>
      <Button text="Invite Client" onClick={toggleModal} />
      <Modal
        open={open}
        title="Invite Client"
        content={
          <div>
            <TextInputWithRegister
              id="email"
              placeholder="Enter client's email..."
              register={register("email")}
            />

            <TextInputWithRegister
              id="name"
              placeholder="Enter client's name..."
              register={register("name")}
            />

            <div className="flex justify-evenly">
              <Button
                text="Cancel"
                theme={buttonTypes.BUTTON_THEME_TYPES.PRIMARY_INVERSE}
                onClick={toggleModal}
                styles="mr-4"
              />
              <Button text="Send" onClick={handleSubmit(save)} />
            </div>
          </div>
        }
        onClose={toggleModal}
      />
    </>
  );
};

export default InviteClientModal;
